import { Type } from ".";

/**
 * image
 * @see {@link https://www.rfc-editor.org/rfc/rfc2046#section-4.2 RFC 2046 §4.2 Image Media Type}
 */
export const ImageType = new Type("image");
